
class OwnerPortalManager {
  private listener: ((popup: boolean) => void) | undefined

  show() {
    this.listener?.(true)
  }

  hide() {
    this.listener?.(false)
  }

  subscribe(fn: (showPopup: boolean) => void) {
    this.listener = fn
  }

  unsubscribe() {
    this.listener = undefined
  }
}

const ownerPortalManager = new OwnerPortalManager()
export default ownerPortalManager
